/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SentenceDirectiveEvent = zod
	.object({
		actor_id: zod
			.string()
			.nullable()
			.describe('ID of the actor who caused the transition (user ID if type is user)'),
		actor_type: zod.enum(['system', 'user']),
		id: zod.string().describe('Event ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		metadata: zod.looseObject({}).describe('Snapshot recorded with the transition (e.g. ends_at)'),
		occurred_at: zod.iso.datetime({ offset: true }).describe('When the transition occurred'),
		reason: zod.string().nullable().describe('Reason recorded with the transition'),
		sentence_directive_id: zod.string().describe('Directive this event belongs to'),
		sentence_id: zod.string().describe('Sentence this event belongs to'),
		type: zod.enum(['activated', 'served', 'revoked', 'voided'])
	})
	.describe('An append-only ledger row recording one directive lifecycle transition');

export type SentenceDirectiveEvent = zod.input<typeof SentenceDirectiveEvent>;
export type SentenceDirectiveEventOutput = zod.output<typeof SentenceDirectiveEvent>;
